<template>
  <div>
    <modal name="BoardPopup" width="1024px" height="auto" :scrollable="true" :clickToClose="false">
      <div id="News_popup">
        <div class="popup_bar">
          <h4 v-if="!EDIT_MODE"> 팝업 공지 추가</h4>
          <h4 v-if="EDIT_MODE">팝업 공지 수정</h4>
          <a @click="btnClose" class="btn_close"></a>
        </div>

        <ul class="contents">
          <li class="tit">제목</li>
          <li class="tit_input">
            <input type="text" v-model="title" />
          </li>
          <div>
            <li class="tit" style="vertical-align: top; line-height: 21px;">팝업 이미지</li>
            <li class="tit_input">
              <file-upload input-id="uploadBg" ref="upload1" v-model="bgImage" :drop="true" :multiple="false">
                <h4>첨부하실 파일을 선택하거나 마우스로 끌어서 넣어주세요.</h4>
                <h4>※ 팝업이미지</h4>
              </file-upload>
            </li>
          </div>
          <li>
            <div v-if="bgImage.length || saveBgImage.length">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>파일이름</th>
                    <th>크기</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fileObj in bgImage" :key="fileObj.id">
                    <td>
                      <img v-if="fileObj.thumb" :src="fileObj.thumb" width="40" height="auto" />
                      <img v-else :src="fileIcon(fileObj.name)" width="40" height="auto" />
                    </td>
                    <td>{{ fileObj.name }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click="deleteBgFile(fileObj)">삭제</button>
                    </td>
                  </tr>
                  <tr v-for="fileObj in saveBgImage" :key="'save_'+fileObj.filename">
                    <td>
                      <img :src="fileIcon(fileObj.filename)" width="40" height="auto" />
                    </td>
                    <td>{{ fileObj.originalname }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click="deleteSaveBgFile(fileObj)">삭제</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>

          <!-- <li>내용</li> -->
          <li class="tit">링크 url </li>
          <li class="tit_input">
            <input type="text" placeholder="예: https://wwww.google.com"  v-model="linkUrl" />
          </li>

          <li class="tit">게시기간</li>
          <li class="day_input">
            <input type="date" v-model="startDt" /> ~
            <input type="date" v-model="endDt" />
          </li>

          <li class="tit">숨김 처리</li>
          <li class="day_input">
            <label><input type="checkbox" v-model="bHide" /> 숨김 (메인 화면 노출 안 됨)</label>
          </li>
        </ul>

        <p class="btn_area">
          <button class="btn_link" @click="btnSave">저장</button>
          <button class="btn_link type02" @click="btnClose">취소</button>
        </p>
      </div>
    </modal>
  </div>
</template>

<script>

import FileUpload from "vue-upload-component";
import pm from "../common/protocolManager";

import { getThumbIcon, filterDate } from "../common/util";


export default {
  components: {
    FileUpload,
  },
  data: () => ({
    message: "PopupWritePopup.vue",
    EDIT_MODE: false,
    title: "",
    linkUrl: "",
    startDt: "",
    endDt: "",
    bHide: false,
    bgImage: [],
    saveBgImage: [],

  }),
  methods: {
    fileIcon(fileName) {
      return getThumbIcon(fileName);
    },
    deleteBgFile(obj) {
      this.bgImage = [];
    },
    deleteSaveBgFile(obj) {
      this.saveBgImage = [];
    },
    deleteFiles(obj) { },
    btnSave() {

      if (this.title.trim() == "") {
        alert("타이틀을 입력하세요");
        return;
      }

      if (this.bgImage.length == 0 && this.saveBgImage.length == 0) {
        alert("팝업 이미지가 필요합니다. ");
        return;
      }

      if (this.linkUrl == "") {
        alert("링크 url 값을 입력해 주세요");
        return;
      }

      if (this.startDt == "") {
        alert("시작일을 확인하세요");
        return;
      }

      if (this.endDt == "") {
        alert("종료일을 확인하세요");
        return;
      }

      let stDate = new Date(this.startDt);
      let etDate = new Date(this.endDt);

      if (stDate.getTime() > etDate.getTime()) {
        alert("시작일과 종료일을 확인하세요");
        return;
      }

      let formData = new FormData();

      formData.append("title", this.title);
      formData.append("linkUrl", this.linkUrl);
      formData.append("startDt", this.startDt);
      formData.append("endDt", this.endDt);
      formData.append("bHide", this.bHide);

      for (let i = 0; i < this.bgImage.length; i++) {
        if (typeof this.bgImage[i].file != "undefined") {
          formData.append("popupImage", this.bgImage[i].file);
        }
      }

      let url = "popupInsert";
      if (this.EDIT_MODE) {
        url = "popupUpdate";
        formData.append("_id", this.$route.query.id);
        if (this.saveBgImage.length != 0) {
          formData.append("saveBgImage", JSON.stringify(this.saveBgImage));
        }
      }
      pm.fileUpload(url, formData)
        .then((result) => {
          alert("팝업 등록 성공");
          this.btnClose();
        })
        .catch((err) => {
          alert("팝업 등록 에러");
          console.log("error = " + err);
        });
    },
    reqDetail() {
      let url = `popupDetail?id=${this.$route.query.id}`;
      pm.get(url)
        .then((result) => {

          this.title = result.detail.title;
          this.linkUrl = result.detail.linkUrl;
          this.startDt = filterDate(result.detail.startDt);
          this.endDt = filterDate(result.detail.endDt);
          this.bHide = result.detail.bHide || false;
          let tempFiles = result.detail.files || {};
          this.saveBgImage = tempFiles.popupImage || [];

        })
        .catch((err) => {
          console.log("btnDetail - error");
        });
    },
    btnClose() {
      this.$modal.hide("BoardPopup");
      this.$router.go(-1);
    },
  },
  mounted() {
    this.$modal.show("BoardPopup");
  },
  computed: {

  },
  destroyed() { },
  created() {
    if (this.$route.query.id) {
      this.EDIT_MODE = true;
      this.reqDetail();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sub02/PopupWritePopup.vue